export type PopupNavigationResult = 'new-tab' | 'same-tab' | 'cancelled';

interface PopupFallbackOptions {
  blockedMessage?: string;
}

function getBlockedMessage(message?: string): string {
  return message ?? 'Your browser blocked opening a new tab for this site. Select OK to continue in the current tab, or Cancel to stay here.';
}

export async function openAsyncUrlWithPopupFallback(
  getUrl: () => Promise<string>,
  options?: PopupFallbackOptions,
): Promise<PopupNavigationResult> {
  const popup = window.open('', '_blank');

  if (popup) {
    try {
      popup.opener = null;
    } catch {
      // Ignore browsers that do not allow setting opener.
    }
  }

  try {
    const url = await getUrl();

    if (popup && !popup.closed) {
      popup.location.replace(url);
      popup.focus?.();
      return 'new-tab';
    }

    if (window.confirm(getBlockedMessage(options?.blockedMessage))) {
      window.location.assign(url);
      return 'same-tab';
    }

    return 'cancelled';
  } catch (error) {
    if (popup && !popup.closed) {
      popup.close();
    }

    throw error;
  }
}

export function openUrlWithPopupFallback(
  url: string,
  options?: PopupFallbackOptions,
): PopupNavigationResult {
  const popup = window.open(url, '_blank');

  if (popup) {
    try {
      popup.opener = null;
    } catch {
      // Ignore browsers that do not allow setting opener.
    }
  }

  if (popup && !popup.closed) {
    popup.focus?.();
    return 'new-tab';
  }

  if (window.confirm(getBlockedMessage(options?.blockedMessage))) {
    window.location.assign(url);
    return 'same-tab';
  }

  return 'cancelled';
}
